import gql from 'graphql-tag';

export const UPDATE_PROPOSAL_PRODUCT = gql`
  mutation ($input: UpdateProposalProductInput!) {
    updateProposalProduct(input: $input) {
      proposalProductId
    }
  }
`;
